import { combineReducers, Action } from "redux";
import ngRedux from "ng-redux";
import ReduxThunk from "redux-thunk";
import { INgReduxProvider } from "./ng-redux";

// eslint-disable-next-line @typescript-eslint/naming-convention
declare const __REDUX_DEVTOOLS_EXTENSION__: any;
declare const window: any;

export function stateManagementModule(reducers: { [key: string]: (state: unknown, action: Action<string>) => unknown }): string {
  const mod = angular.module("state-management", [ngRedux]);
  mod.config([
    "$ngReduxProvider",
    function ($ngReduxProvider: INgReduxProvider) {
      const storeEnhancers: any = [];
      const storeMiddlewares = [];

      // if redux chrome devtools extension is installed and enabled
      if (window && window.__REDUX_DEVTOOLS_EXTENSION__) {
        storeEnhancers.push(__REDUX_DEVTOOLS_EXTENSION__());
      }

      storeMiddlewares.push(ReduxThunk);

      const rootReducer = combineReducers(reducers);

      $ngReduxProvider.createStoreWith(rootReducer, storeMiddlewares, storeEnhancers);
    },
  ]);
  return mod.name;
}
